import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-24 md:py-32 px-5 sm:px-6 md:px-8 bg-gradient-to-b from-[#0a0a0a] to-carbon" data-id="element-129">
      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="p-8 md:p-12 rounded-2xl border border-gold/20 bg-gold/5 backdrop-blur-sm shadow-[0_0_50px_rgba(242,183,5,0.05)] flex flex-col items-center" data-id="element-131">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6" data-id="element-132">
            Agenda tu consulta estratégica gratuita
          </h2>
          <p className="text-gray-400 text-base sm:text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-133">
            Descubre cómo el Sistema A.C.E.™ Clínico puede transformar tu
            agenda y multiplicar los ingresos de tu clínica en los próximos 30
            días.
          </p>

          <div className="flex flex-col items-center w-full gap-4" data-id="element-134">
            <CTAButton text="QUIERO LLENAR MI AGENDA CLÍNICA" className="w-full md:w-auto md:px-12 md:py-5 text-lg md:text-xl" data-id="element-135" />
            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-yellow-400 hover:underline transition-colors text-sm md:text-base font-medium mt-2 flex items-center justify-center" data-id="element-136">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-137">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-138" />
              </svg>
              O agenda directamente tu cita aquí
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}